import { EmployeeDTO } from '@Models/model.types';
import { AdditionsDeductionsModal } from '@Page/EmployeeOverview/modals/AdditionsDeductionsModal';
import { AssignEntitlementsModal } from '@Page/EmployeeOverview/modals/assignEntitlements/AssignEntitlementsModal';
import { ChangeEmployeeInfoModal } from '@Page/EmployeeOverview/modals/changeEmployeeInfo/ChangeEmployeeInfoModal';
import { EndEmploymentsModal } from '@Page/EmployeeOverview/modals/endEmployment/EndEmploymentModal';
import { UnionDeductionModal } from '@Page/EmployeeOverview/modals/unionDeduction/UnionDeductionModal';
import { WageAdjustmentModal } from '@Page/EmployeeOverview/modals/wageAdjstment/WageAdjustmentModal';
import { ListResponse } from '@tlx/astro-shared';
import { Dispatch, SetStateAction } from 'react';
import { SWRInfiniteKeyedMutator } from 'swr/infinite';

export type ModalType =
    | 'changeEmployeeInfo'
    | 'assignEntitlements'
    | 'wageAdjustment'
    | 'additionsDeductionsn'
    | 'endEmployments'
    | 'unionDeduction'
    | 'taxcard';

export function BatchActionModals({
    activeModal,
    onClose,
    employeeIds,
    setValidationsMap,
    mutate,
}: {
    activeModal: ModalType | null;
    onClose: () => void;
    employeeIds: number[];
    setValidationsMap: Dispatch<SetStateAction<Map<number, string[]>>>;
    mutate: SWRInfiniteKeyedMutator<ListResponse<EmployeeDTO>[]>;
}) {
    return (
        <>
            <AssignEntitlementsModal
                open={activeModal === 'assignEntitlements'}
                onClose={onClose}
                employeeIds={employeeIds}
                setValidationsMap={setValidationsMap}
                mutate={mutate}
            />
            <ChangeEmployeeInfoModal
                open={activeModal === 'changeEmployeeInfo'}
                onClose={onClose}
                employeeIds={employeeIds}
                setValidationsMap={setValidationsMap}
                mutate={mutate}
            />
            <WageAdjustmentModal
                open={activeModal === 'wageAdjustment'}
                onClose={onClose}
                employeeIds={employeeIds}
                setValidationsMap={setValidationsMap}
                mutate={mutate}
            />
            {/*  <TaxcardModal
                        open={activeModal === "taxcard"}
                        setOpen={onClose}
                        altinn={altinn}
                        checkMachinery={checkMachinery}
                    /> */}
            <AdditionsDeductionsModal
                open={activeModal === 'additionsDeductionsn'}
                onClose={onClose}
                employeeIds={employeeIds}
                setValidationsMap={setValidationsMap}
            />
            <EndEmploymentsModal
                open={activeModal === 'endEmployments'}
                onClose={onClose}
                employeeIds={employeeIds}
                setValidationsMap={setValidationsMap}
                mutate={mutate}
            />
            <UnionDeductionModal
                open={activeModal === 'unionDeduction'}
                onClose={onClose}
                employeeIds={employeeIds}
                setValidationsMap={setValidationsMap}
                mutate={mutate}
            />
        </>
    );
}
